import { render } from "./MenuAccordion.vue?vue&type=template&id=917b644a"
import script from "./MenuAccordion.vue?vue&type=script&lang=js"
export * from "./MenuAccordion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Logica Yachts\\Front\\Logica-Yachts\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__